import { dom as o } from "./index339.js";
import { env as r } from "./index551.js";
function i(e) {
  if (r.isServer) return null;
  if (e instanceof Node) return e.ownerDocument;
  if (e != null && e.hasOwnProperty("value")) {
    let n = o(e);
    if (n) return n.ownerDocument;
  }
  return document;
}
export {
  i as getOwnerDocument
};
